var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.4 24.83",
    style: {
      enableBackground: "new 0 0 18.4 24.83"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{opacity:0.6952;clip-path:url(#SVGID_00000134230479852891130750000005509612299918222216_);fill:#E81410;enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "10.64,21.27 8.78,21.27 8.78,5.97 4.43,10.32 3.11,9 9.71,2.4 16.31,9 14.99,10.32 10.64,5.97  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160901603960405711580000000636088475782468789_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -2.63,
    y: -0.51,
    style: {
      opacity: 0.6952,
      clipPath: "url(#SVGID_00000160901603960405711580000000636088475782468789_)",
      fill: "#E81410",
      enableBackground: "new"
    },
    width: 24.68,
    height: 24.68
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrowUp);
export default __webpack_public_path__ + "static/media/red-arrow-up.5447273a916a3b8711b361a2b4f01b4b.svg";
export { ForwardRef as ReactComponent };